module.exports = __webpack_public_path__ + "img/step3-en.4ce9f3f4.webp";